/**
 * The lobby's ONE title: the table's own logo, big, and nothing else (Marko 22.9.2026: "ihan isolla pelkästään se flirt
 * tai meet logo. Tai sitten friends logo tai date logo. Niin se pitää olla." — no SAY NO WAY wordmark, no TABLE word).
 * One element for every lobby (Friends, Date, Meet, Flirt); the pieces are the owner's room logos cut by
 * art/src/room-logos-2026-09-21/lobby-logo.mjs, placed by left/top/width only — the height follows the picture.
 */
import { art } from '../art';

export type LobbyKind = 'meet' | 'flirt' | 'friends' | 'date';
/** 440 wide between the two upper stickers (68-232 and 742-940): centred on 487, its top at 8 */
const LOGO = { left: 267, top: 8, width: 440 } as const;
const PIECE: Record<LobbyKind, string> = {
  meet: '/art/room-logos/lobby-meet.png', flirt: '/art/room-logos/lobby-flirt.png',
  friends: '/art/room-logos/lobby-friends.png', date: '/art/room-logos/lobby-date.png',
};

export function LobbyLogo({ kind }: { kind: LobbyKind }) {
  return <img class="cut" src={art(PIECE[kind])} alt="" draggable={false} style={{ ...LOGO, zIndex: 12 }} data-testid="lobby-logo" data-kind={kind} />;
}
